import React from "react";
// Styles
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material";

export const SelectGenero = ({ handleChange, user, errors }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.sexo}
        className={classes.formControlCustom}
      >
        <InputLabel id="sexo-label">Género*</InputLabel>
        <Select
          labelId="sexo-label"
          id="sexo"
          name="sexo"
          value={user.sexo}
          className={classes.inputCustom}
          onChange={(e) => handleChange(e)}
          label="Género*"
          sx={{
            "& .MuiMenuItem-root": {
              boxShadow: "none",
            },
            "& .MuiPaper-root": {
              border: "1px solid #d3d4d5",
            },
            "&:after": {
              borderBottom: "2px solid rgb(4 128 143)",
            },
          }}
        >
          <MenuItem value="F">FEMENINO</MenuItem>
          <MenuItem value="M">MASCULINO</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
};

export const SelectNacionalidad = ({
  setUser,
  user,
  errors,
  nacionalidades,
}) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.nacionalidad}
        className={`${classes.formControlCustomAutocomplete} ${
          errors.nacionalidad != null ? classes.colorRed : ""
        }`}
      >
        <Autocomplete
          disablePortal
          id="nacionalidad"
          name="nacionalidad"
          value={user.nacionalidad}
          className={classes.inputAutocomplete}
          options={nacionalidades}
          onChange={(e, v) => {
            // handleChange(e);
            setUser({ ...user, nacionalidad: v });
          }}
          renderInput={(params) => (
            <TextField
              inputProps={{ autocomplete: "off" }}
              {...params}
              label="País de nacimiento*"
            />
          )}
        />
      </FormControl>
    </Grid>
  );
};

export const SelectTipoEmpleo = ({
  handleChange,
  user,
  errors,
  tiposEmpleo,
}) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idTipoEmpleo}
        className={classes.formControlCustom}
      >
        <InputLabel id="tipoEmpleo-label">Tipo de empleo*</InputLabel>
        <Select
          labelId="tipoEmpleo-label"
          id="idTipoEmpleo"
          name="idTipoEmpleo"
          className={classes.inputCustom}
          value={user.idTipoEmpleo}
          onChange={(e) => handleChange(e)}
          label="Tipo de empleo*"
        >
          {tiposEmpleo.map((tipoEmpleo) => (
            <MenuItem key={tipoEmpleo.codigo} value={tipoEmpleo.codigo}>
              {tipoEmpleo.descripcionProfesion}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export const SelectCargo = ({ handleChange, user, errors, cargos }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idCargo}
        className={classes.formControlCustom}
      >
        <InputLabel id="cargo-label">Cargo*</InputLabel>
        <Select
          labelId="cargo-label"
          id="idCargo"
          name="idCargo"
          value={user.idCargo}
          className={classes.inputCustom}
          onChange={(e) => handleChange(e)}
          label="Cargo*"
        >
          {cargos.length > 0 ? (
            cargos.map((cargo) => (
              <MenuItem key={cargo.codigoRamo} value={cargo.codigoRamo}>
                {cargo.descripcionRamo}
              </MenuItem>
            ))
          ) : (
            <MenuItem key={0} value={0}>
              Seleccione tipo de empleo
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </Grid>
  );
};

export const IngresoLiquido = ({ handleOnInput, user, errors, show }) => {
  const classes = useStyles();
  if (!show) return null;
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idCargo}
        className={classes.formControlCustom}
      >
        <TextField
          id="ingresoLiquido"
          name="ingresoLiquido"
          label="Ingreso líquido*"
          variant="filled"
          value={user.ingresoLiquido}
          onInput={(e) => handleOnInput(e)}
          error={!!errors.ingresoLiquido}
          className={`${classes.inputCustom}`}
        />
      </FormControl>
    </Grid>
  );
};

export const SelectDepartamento = ({
  handleChange,
  user,
  errors,
  departamentos,
}) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idDepartamento}
        className={classes.formControlCustom}
      >
        <InputLabel id="departamento-label">Departamento*</InputLabel>
        <Select
          labelId="departamento-label"
          id="idDepartamento"
          name="idDepartamento"
          className={classes.inputCustom}
          value={user.idDepartamento}
          onChange={(e) => handleChange(e)}
          label="Departamento*"
        >
          {departamentos.map((depto) => (
            <MenuItem key={depto.idDepto} value={depto.idDepto}>
              {depto.departamento}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export const SelectBarrio = ({ handleChange, user, errors, localidades }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idBarrio}
        className={classes.formControlCustom}
      >
        <InputLabel id="barrio-label">Barrio / Localidad*</InputLabel>
        <Select
          labelId="barrio-label"
          id="idBarrio"
          name="idBarrio"
          value={user.idBarrio}
          onChange={(e) => handleChange(e)}
          className={classes.inputCustom}
          label="Barrio*"
        >
          {user.idDepartamento ? (
            localidades.map((localidad) => (
              <MenuItem
                key={localidad.idLocalidad}
                value={localidad.idLocalidad}
              >
                {localidad.localidadBarrio}
              </MenuItem>
            ))
          ) : (
            <MenuItem key={0} value={0}>
              Seleccione un departamento
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </Grid>
  );
};

export const SelectTipoDireccion = ({ handleChange, user, errors }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idTipoDireccion}
        className={classes.formControlCustom}
      >
        <InputLabel id="tipo-direccion-label">Tipo de dirección*</InputLabel>
        <Select
          labelId="tipo-direccion-label"
          id="idTipoDireccion"
          name="idTipoDireccion"
          value={user.idTipoDireccion}
          className={classes.inputCustom}
          onChange={(e) => handleChange(e)}
          label="Tipo de dirección*"
        >
          <MenuItem value="1">CALLE Y NÚMERO DE PUERTA</MenuItem>
          <MenuItem value="2">CALLE, MANZANA Y SOLAR</MenuItem>
          <MenuItem value="3">RUTA - KILÓMETRO</MenuItem>
          <MenuItem value="4">NOMBRE DEL INMUEBLE</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
};

export const Direccion = ({ handleChange, user, errors, label }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idTipoDireccion}
        className={classes.formControlCustom}
      >
        <TextField
          id="dirección"
          name="dirección"
          label={label}
          variant="filled"
          value={user.dirección}
          onChange={(e) => handleChange(e)}
          error={!!errors.dirección}
          className={classes.inputCustom}
          inputProps={{ maxLength: 30 }}
        />
        <p className={classes.textoDescriptivo}>
          Máximo <span className="special-font">30</span> caracteres.
        </p>
      </FormControl>
    </Grid>
  );
};

export const Esquinas = ({ handleChange, user, errors, show }) => {
  const classes = useStyles();
  if (!show) return null;
  return (
    <>
      <Grid item xs={12} sm={6} className={classes.gridForm}>
        <FormControl
          fullWidth
          variant="filled"
          error={!!errors.esquina1}
          className={classes.formControlCustom}
        >
          <TextField
            id="esquina1"
            name="esquina1"
            label="Esquina 1"
            variant="filled"
            value={user.esquina1}
            error={!!errors.esquina1}
            onChange={(e) => handleChange(e)}
            className={classes.inputCustom}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} className={classes.gridForm}>
        <FormControl
          fullWidth
          variant="filled"
          error={!!errors.esquina2}
          className={classes.formControlCustom}
        >
          <TextField
            id="esquina2"
            name="esquina2"
            label="Esquina 2"
            variant="filled"
            value={user.esquina2}
            error={!!errors.esquina2}
            onChange={(e) => handleChange(e)}
            className={classes.inputCustom}
          />
        </FormControl>
      </Grid>
    </>
  );
};

export const ObservacionesDireccion = ({ handleChange, user, errors }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={12} className={classes.gridForm}>
      <FormControl
        fullWidth
        variant="filled"
        error={!!errors.idTipoDireccion}
        className={classes.formControlCustom}
      >
        <TextField
          id="observacionesDireccion"
          name="observacionesDireccion"
          label="Descripción del domicilio"
          variant="filled"
          className={classes.inputCustom}
          value={user.observacionesDireccion}
          onChange={(e) => handleChange(e)}
          multiline={true}
          rows={5}
        />
        <p className={classes.textoDescriptivo}>
          *Todos los campos con asterisco son obligatorios.
        </p>
      </FormControl>
    </Grid>
  );
};
